<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:76%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="'Ανακοινώσεις'" action='newAnnouncement'></app-page-header>
        </mat-card-title>

        <mat-card-content fxLayout="column">

            <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start center center" style="margin-top:50px;">

                <!--    Loading-->
                <div *ngIf="isLoading">
                    <app-skeleton-loading></app-skeleton-loading>
                </div>
                <!---->

                <!--                Search Row -->
                <div *ngIf="!isLoading" fxLayout="row" fxLayoutGap="20px" fxFlex="grow" fxFlex="grow"
                     ngStyle.md="width:90%"
                     ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:100%">

                    <mat-form-field>
                        <mat-label>Αναζήτη τίτλου</mat-label>
                        <label>
                            <input matInput [(ngModel)]="searchAnnouncementValue" (keydown)="searchForms(2) ">
                        </label>
                        <button mat-button matSuffix mat-icon-button aria-label="search" (click)="search()">
                            <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>


                <div *ngIf="!isLoading" fxLayout="row" fxFlex="grow"
                     ngStyle.md="width:90%"
                     ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:100%">

                    <div fxLayout="column" fxFlex="grow">
                        <div fxLayoutAlign="flex-start" *ngFor="let form of displayAnnouncements" fxLayout="row">

                            <app-form-card [form]="form" mode="2" fxFlex="98"
                                           (deleteFormEmit)="deleteFormEmittedFromChild($event)"></app-form-card>
                        </div>
                    </div>
                </div>

            </div>
        </mat-card-content>
    </mat-card>

</div>
